import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { CaptchaModule } from 'primeng/captcha';
import { MessageService } from 'primeng/api';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AccountService } from 'src/app/modules/shared/services/account.service';

@Component({
  selector: 'aca-recaptcha',
  templateUrl: './recaptcha.component.html',
  styleUrls: ['./recaptcha.component.css']
})
export class RecaptchaComponent implements OnInit, OnDestroy {
  @Input() RecaptchaPublicKey: string;
  @Output() verifyUser = new EventEmitter<boolean>(true);

  /// <summary>
  /// Defines wether the control should be rendered as 'normal' or 'compact'
  /// </summary>
  SizeMode = 'compact';
  protected destroyActions = new Subject<boolean>();

  constructor(private accountService: AccountService, private messageService: MessageService) { }

  ngOnInit(): void {
  }

  showResponse(response) {
    this.accountService.verifyCaptchaData(response.response)
      .pipe(takeUntil(this.destroyActions))
      .subscribe((s => {
        this.verifyUser.emit(s.success);
        return s;
      })
      ,error => {
        this.messageService.add({
          severity: 'error',
          summary: error,
          closable: false
        });
      });
  }

  ngOnDestroy(): void {
    this.destroyActions.next(null);
    this.destroyActions.complete();
  }
}
